// Native & external imports
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
// Routes
import { AppRoutes } from './routes';

@Injectable({
  providedIn: 'root',
})

export class AppRouterService {

  // Service variable consisting of components url from route config file.
  public componentsUrl = AppRoutes.componentsUrl;

  // Service variable consisting of backend url from route config file.
  public backendApiUrl = AppRoutes.backendApiUrl;

  // Helper function to construct the full api url.
  getApiUrl(api: string) {
    return environment.apiUrl + '/' + api;
  }

  /**
   * Replace the param with the given value
   * @param url string - url/has/:id/and/:name
   * @param param_1 string - id:1
   * @param param_2 string - name:john
   * @return string
   */
  customizeUrl(url: string, param_1: string, param_2 = '', param_3 = '') {
    const paramSplit_1 = param_1.split(':');
    let newUrl = url.replace(':' + paramSplit_1[0], paramSplit_1[1]);
    if (param_2 !== '') {
      const paramSplit_2 = param_2.split(':');
      newUrl = newUrl.replace(':' + paramSplit_2[0], paramSplit_2[1]);
    }
    if (param_3 !== '') {
      const paramSplit_3 = param_3.split(':');
      newUrl = newUrl.replace(':' + paramSplit_3[0], paramSplit_3[1]);
    }
    return newUrl;
  }
}
